import { useThemeSlice } from "../../components/ui/StatusBadge.jsx";
import { getManagerCardLift } from "../../components/ui/cardStyles.js";
import { SearchField } from "../../components/ui/SearchField.jsx";
import { SidebarEmptyHint } from "../../components/emptyStates/SidebarEmptyHint.jsx";
import { UsersRouteSkeleton } from "../../components/skeletons/UsersRouteSkeleton.jsx";
import { UserListItem } from "./UserListItem.jsx";
import { UserDetailHeader } from "./UserDetailHeader.jsx";
import { UserProfilePanel } from "./UserProfilePanel.jsx";

export function UsersListPanel({
  users,
  loading,
  search,
  onSearchChange,
  selectedId,
  onSelect,
  selectedUser,
  permissions,
  permsLoading,
  onRemovePermission,
  onDisableUser,
  onEnableUser,
  statusSaving,
  addPermOpen,
  onToggleAddPerm,
  addablePermissions,
  onAddPermission,
}) {
  const { c, dark, accentHex: A } = useThemeSlice();
  const cardLift = getManagerCardLift(dark);

  if (loading) {
    return <UsersRouteSkeleton />;
  }

  return (
    <div style={{ flex: 1, minHeight: 0, overflow: "hidden", padding: "14px" }}>
      <div style={{ background: c.card, border: `1px solid ${c.cardBdr}`, borderRadius: 12, height: "100%", minHeight: 0, display: "grid", gridTemplateColumns: "280px 1fr", overflow: "hidden", boxShadow: cardLift }}>
        <div style={{ borderRight: `1px solid ${c.cardBdr}`, display: "flex", flexDirection: "column", background: c.sb, minHeight: 0 }}>
          <div style={{ padding: "12px 14px 10px", borderBottom: `1px solid ${c.cardBdr}` }}>
            <SearchField value={search} onChange={onSearchChange} placeholder="Search users…" variant="sidebar" />
          </div>

          <div style={{ overflow: "auto", flex: 1, padding: "2px 10px 10px" }}>
            {users.length === 0 ? (
              <SidebarEmptyHint c={c}>{search.trim() ? "No matching users" : "No users found"}</SidebarEmptyHint>
            ) : (
              users.map((user) => (
                <UserListItem key={user.id} user={user} selected={user.id === selectedId} onSelect={onSelect} c={c} dark={dark} A={A} />
              ))
            )}
          </div>
        </div>

        <div style={{ minWidth: 0, display: "flex", flexDirection: "column", background: c.card }}>
          <UserDetailHeader user={selectedUser} onDisable={onDisableUser} onEnable={onEnableUser} onAddPermission={() => onToggleAddPerm(true)} statusSaving={statusSaving} c={c} dark={dark} A={A} />
          <div style={{ padding: 18, overflow: "auto", minHeight: 0, flex: 1 }}>
            <UserProfilePanel user={selectedUser} permissions={permissions} permsLoading={permsLoading} onRemovePermission={onRemovePermission} addPermOpen={addPermOpen} addablePermissions={addablePermissions} onAddPermission={onAddPermission} onCloseAdd={() => onToggleAddPerm(false)} c={c} dark={dark} A={A} />
          </div>
        </div>
      </div>
    </div>
  );
}
